<template lang="pug">
    Card(:bordered="false" dis-hover)
        Button(slot="extra" @click="editAction" v-if="$store.getters.isAdmin") Edit {{categoryName}} Subscription    
        div
            pre
                strong(style="font-size: 20px") {{usage}} 
                |  of {{subscriptionCount}} {{categoryName}}
            Tooltip(:content="percentageTooltip+`%`" style="width: 100%")
                Progress(:percent="percentage" hide-info :strokeColor="progressStrokeColor" )   
        Modal(v-model="editSubscription" :title="`Edit `+categoryName+` Subscription`" @on-ok="updateCategorySubscription(subscriptionValue)")
            InputNumber(v-model="subscriptionValue" :min="0" :max="maxCountKey" :active-change="false")
        Spin(size="large" fix v-if="spinShow")
</template>
<script>
import { getGroupAsset, updateSubscription } from "@/api/groupasset.js";

export default {
    props: {
        usage: { type: Number, default: 0 },
        subscription: { type: Number, default: 0 },
        category: "",
        categoryName: "",
        groupName: "",
        maxCountKey: { type: Number, default: -1 }
    },
    data() {
        return {
            categoryData: {},
            spinShow: false,
            editSubscription: false,
            subscriptionValue: 0
        };
    },
    computed: {
        percentageTooltip() {
            return ((this.usage / this.subscriptionCount) * 100).toFixed();
        },
        percentage() {
            // 如果值為0則顯示0，如果值大於100則顯示100，其餘就照計算結果
            return this.usage == 0
                ? 0
                : (this.usage / this.subscriptionCount) * 100 > 100
                ? 100
                : (this.usage / this.subscriptionCount) * 100;
        },
        progressStrokeColor() {
            let color = this.percentage < 40 ? "#1dbd8f" : this.percentage < 70 ? "#ffb001" : "#fe5000";
            return color;
        },
        subscriptionCount() {
            return this.subscription == 0 ? this.maxCountKey : this.subscription;
        }
    },
    methods: {
        editAction() {
            this.editSubscription = true;
            this.subscriptionValue = this.subscription;
        },
        updateCategorySubscription(subscriptionValue) {
            this.spinShow = true;
            updateSubscription({
                category: this.category,
                groupNames: this.groupName,
                subscription: subscriptionValue
            }).then(res => {
                this.spinShow = false;
                this.$emit("updateSuccess");
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/subscriptionContent.vue